import React, { useState, useEffect } from 'react';
import { Button, Form, Container, Row, Col, Card, Modal } from 'react-bootstrap';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import NewCampaign from '../components/NewCampaign';
import { getCampaigns, getAnalyzeDataByPostUrl } from '../services/api';
import { useNavigate } from 'react-router-dom';
import '../styles/Campaigns.css';

export default function CampaignList() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [campaigns, setCampaigns] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [postUrl, setPostUrl] = useState('');

    const handleCampaignClick = (campaign) => {
        navigate("/campaignDetails", { state: { campaignData: campaign } });
    };

    useEffect(() => {
        async function fetchCampaigns() {
            try {
                const response = await getCampaigns();
                setCampaigns(response.data);
            } catch (error) {
                console.error("Error fetching campaigns:", error);
            }
        }

        fetchCampaigns();
    }, []);

    function formatDateString(dateString) {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', options).replace(',', '').replace(' at', ',');
    }

    const handleAnalyzeClick = async () => {
        // Validate postUrl before calling the API
        if (!postUrl || postUrl.trim() === '') {
            alert('Please enter a valid post URL.');
            return;
        }
        
        try {
            const response = await getAnalyzeDataByPostUrl(postUrl);
    
            // Ensure we extract the data property from the response
            if (response?.data && Array.isArray(response.data)) {
                if (response.data.length > 0) {
                    // Pick the first object from the returned data
                    const selectedObject = response.data[0];
                    
                    // Redirect to another page with the selected object
                    navigate('/campaignAnalysis', { state: { postData: selectedObject } });
                } else {
                    alert("No data found for the given post URL.");
                }
            } else {
                console.warn("Unexpected API response format:", response);
                alert("Unexpected API response format.");
            }
        } catch (error) {
            console.error("Error fetching influencers data:", error);
            alert(`Error fetching influencers data: ${error.message}`);
        }
    };
    
    

    return (
        <div style={{padding: '15px'}}>
         {/* <Container className="content"> */}
            <Row className="justify-content-center">
                <Col md={12} className="analysis-box text-center">
                    <h3>Get detailed insights on any social media post</h3>
                    <Form className="input-box d-flex">
                        <Form.Control
                            type="text"
                            placeholder="Paste a post link (URL) from Instagram OR TikTok"
                            value={postUrl}
                            onChange={(e) => setPostUrl(e.target.value)}
                        />
                        <Button variant="primary" className="ms-2" onClick={handleAnalyzeClick}>Analyze</Button>
                    </Form>
                </Col>
            </Row>

            <Row className="">
                <Col md={12} className="upgrade-box text-center">
                    Create a campaign and explore our sample campaign. <a href="#">Upgrade</a> to create more campaigns!
                </Col>
            </Row>

            <Row className="mt-4">
      <Col md={12} className="campaign-section">
        <Card>
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h2 className="mb-0">Your campaigns</h2>
              <Button variant="success" onClick={handleShow}>+ NEW CAMPAIGN</Button>
            </div>

            <div className="table-responsive mt-3">
  <MDBTable hover className="custom-campaign-table w-100">
    <MDBTableHead>
      <tr>
        <th className="col-campaign">Campaign</th>
        <th className="col-posts">Posts</th>
        <th className="col-date">Created on</th>
      </tr>
    </MDBTableHead>
    <MDBTableBody>
      {campaigns.map((campaign) => (
        <tr
          key={campaign.campaignID}
          onClick={() => handleCampaignClick(campaign)}
          style={{ cursor: 'pointer' }}
        >
          <td className="campaign-name">{campaign.name}</td>
          <td>{campaign.posts || 'N/A'}</td>
          <td>{formatDateString(campaign.createdAt)}</td>
        </tr>
      ))}
    </MDBTableBody>
  </MDBTable>
</div>

          </Card.Body>
        </Card>
      </Col>
    </Row>

            <NewCampaign isOpen={show} handleClose={handleClose} />
        {/* </Container> */}
        </div>
    );
}
